import React, { useContext } from 'react';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';
import AodIcon from '@mui/icons-material/Aod';
import MobileOffIcon from '@mui/icons-material/MobileOff';
import { uri } from '../utils/config';

const DigitalMenuPreview = (props) => {
  const { showDigitalMenu, toggleShowDigitalMenu, random } = props;
  const [placeState] = useContext(PlaceStoreContext);
  const {
    place: { id: placeId },
  } = placeState;
  const minWidth = 280;
  const minHeight = 680;
  const relativeHeight = Math.ceil((window.innerWidth / 4) * 1.64);
  const relativeWidth = Math.ceil(window.innerWidth / 4);
  const iframeHeight = `${relativeHeight < minHeight ? minHeight : relativeHeight}px`;
  const iframeWidth = `${relativeWidth < minWidth ? minWidth : relativeWidth}px`;

  const showPreview = window.innerWidth > 518;

  if (!showPreview) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '71px',
        right: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          margin: '0px -5px 5px 0px',
        }}
        onClick={toggleShowDigitalMenu}
      >
        <p style={{ fontSize: '0.7rem', fontWeight: 'bold', color: '#000000A1' }}>
          {!showDigitalMenu ? 'VIEW DIGITAL MENU' : 'HIDE DIGITAL MENU'}
        </p>
        {showDigitalMenu ? (
          <MobileOffIcon className="txt-black s-32-i" />
        ) : (
          <AodIcon className="txt-black s-32-i" />
        )}
      </div>
      <div>
        {showDigitalMenu && (
          <iframe
            key={random}
            style={{ borderRadius: '4px' }}
            width={iframeWidth}
            height={iframeHeight}
            frameBorder="0"
            src={`https://${uri.env}digital-menu.${process.env.REACT_APP_DOMAIN}/${placeId}?gdpr=false`}
            title="Digital Menu"
          />
        )}
      </div>
    </div>
  );
};

export default DigitalMenuPreview;
